( function () {
	'use strict';

	function collectionService () {
		function getIndex ( collection, model ) {
			return collection.indexOf( model );
		}

		function addModel ( collection, data ) {
			collection.push( data );
		}

		function addModelAtIndex ( collection, data, index ) {
			collection.splice( index, 0, data );
		}

		function addModelWithId ( collection, data, idField ) {
			data[ idField ] = collection.length + 1;
			addModel( collection, data );
		}

		function removeModel ( collection, model ) {
			collection.splice( getIndex( collection, model ), 1 );
		}

		function moveModel ( collection, model, direction ) {
			var index = getIndex( collection, model );

			removeModel( collection, model );
			collection.splice( index + direction, 0, model );
		}

		return {
			'getIndex'        : getIndex,
			'addModel'        : addModel,
			'addModelWithId'  : addModelWithId,
			'addModelAtIndex' : addModelAtIndex,
			'removeModel'     : removeModel,
			'moveModel'       : moveModel,
			'moveUp'          : -1,
			'moveDown'        : 1
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'collectionService', collectionService );
} )( );
